import type { LocalVideoComponentProps } from "../../core/types";

/**
 * Displays camera preview before joining, live video during session.
 */
export function ZoomLocalVideo({
  videoProps,
  videoRef,
}: LocalVideoComponentProps) {
  const { className } = videoProps;

  return (
    <video-player-container class={className} style={{ width: "auto" }}>
      <video-player ref={videoRef} />
    </video-player-container>
  );
}
